// avstemming-tax-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avg.common.ofCount': '{done} av {total}',
  'avg.derived.betaling_mangler': 'Forfalte krav uten betaling er behandlet',
  'avg.derived.betalt_for_sent': 'Krav betalt etter forfall er behandlet',
  'avg.derived.delvis_betalt': 'Delbetalte krav er behandlet',
  'avg.derived.bokforingsdifferanse': 'Differanser mellom krav og bokført gjeld er behandlet',
  'avg.derived.ikke_bokfort': 'Krav uten bokført gjeld er behandlet',
  'avg.derived.ikke_meldt': 'Lønnskjøringer som ikke er registrert meldt er behandlet',
  'avg.derived.mva_ikke_levert': 'MVA-oppgjør som ikke er ferdigstilt er behandlet',
  'avg.derived.direktefort': 'Direkteføringer på kontrollkontoene er vurdert',
  'avg.derived.uten_bankdekning': 'Betalinger uten bekreftelse i bankutskriften er behandlet',
  'avg.checklist.title': 'Faglig sjekkliste',
  'avg.checklist.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avg.checklist.empty': 'Ingen kontrollpunkter er definert for skatt og offentlige avgifter i denne perioden.',
  'avg.checklist.intro': 'Punktene gjelder hele skatteområdet. En avkryssing lagres på alle kontrollkontoene i perioden.',
  'avg.checklist.groupItems': 'Poster som krever behandling',
  'avg.checklist.processed': '{done} av {total} behandlet',
  'avg.checklist.notRelevant': 'Ikke aktuelt denne perioden',
  'avg.checklist.autoTag': 'Følger av vurderingene',
  'avg.checklist.groupAssessment': 'Overordnede faglige vurderinger',
  'avg.checklist.groupReady': 'Klarstilling',
  'avg.checklist.performedBy': 'Utføres av {name}',
  'avg.checklist.completed': '{done} av {total} kontrollpunkter fullført',
  'avg.blocker.itemsOne': '{count} forhold krever vurdering',
  'avg.blocker.itemsMany': '{count} forhold krever vurdering',
  'avg.blocker.accounts': '{count} kontrollkonto avviker fra det beregnede grunnlaget',
  'avg.blocker.overdue': '{count} forfalt krav er ikke betalt',
  'avg.blocker.controlsOne': '{count} kontrollpunkt gjenstår',
  'avg.blocker.controlsMany': '{count} kontrollpunkter gjenstår',
  'avg.concl.title': 'Konklusjon og godkjenning',
  'avg.concl.label': 'Konklusjon',
  'avg.concl.placeholder': 'Hva viser gjennomgangen av skatt og offentlige avgifter for denne perioden?',
  'avg.concl.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avg.concl.remainingRisk': 'Gjenstående risiko',
  'avg.concl.noBlockers': 'Ingenting står igjen som hindrer at området sendes til kontroll. Skatteetatens egen kravoversikt er ikke hentet — avstemmingen er gjort mot foretakets egne beregnede krav.',
  'avg.concl.followUpTitle': 'Oppfølging neste periode',
  'avg.concl.followUpEmpty': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avg.concl.followUpBadge': 'Følges opp',
  'avg.concl.measure': 'Tiltak: {value}',
  'avg.concl.noMeasure': 'Ingen tiltak notert',
  'avg.concl.deadline': 'Frist {date}',
  'avg.concl.openAssessment': 'Åpne vurdering',
  'avg.concl.sendToControl': 'Send området til kontroll',
  'avg.concl.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avg.concl.manyLeft': '{count} ting står igjen før området kan sendes.',
  'avg.common.close': 'Lukk',
  'avg.common.requestDocs': 'Be klienten om dokumentasjon',
  'avg.common.status': 'Status',
  'avg.common.viewAssessment': 'Se vurdering',
  'avg.common.assess': 'Vurder',
  'avg.common.openPayroll': 'Åpne lønnsavstemming',
  'avg.common.openVat': 'Åpne MVA-avstemming',
  'avg.col.booked': 'Bokført',
  'avg.col.paid': 'Betalt',
  'avg.col.rest': 'Rest',
  'avg.col.assessment': 'Vurdering',
  'avg.col.due': 'Forfall',
  'avg.col.period': 'Periode',
  'avg.col.difference': 'Differanse',
  'avg.col.details': 'Detaljer',
  'avg.col.date': 'Dato',
  'avg.col.amount': 'Beløp',
  'avg.col.claim': 'Krav',
  'avg.drawer.due': 'Forfall {date}',
  'avg.drawer.calculatedClaim': 'Beregnet krav',
  'avg.drawer.rationale': 'Faglig begrunnelse',
  'avg.drawer.rationaleRequired': 'Faglig begrunnelse (påkrevd)',
  'avg.drawer.rationalePlaceholder': 'Hva gjelder forholdet, og hva bygger vurderingen på?',
  'avg.drawer.measure': 'Tiltak',
  'avg.drawer.measurePlaceholder': 'F.eks. Betal kravet, korriger gjelden på bilaget, eller be om dokumentasjon',
  'avg.drawer.followUpDeadline': 'Frist for oppfølging',
  'avg.drawer.followUpNext': 'Følges opp neste periode',
  'avg.drawer.needsRationale': 'Denne vurderingen krever en begrunnelse.',
  'avg.drawer.save': 'Lagre vurdering',
  'avg.status.incomplete': 'Ikke komplett',
  'avg.sources.title': 'Datakilder',
  'avg.sources.missingOne': '{count} kilde er ikke komplett for perioden.',
  'avg.sources.missingMany': '{count} kilder er ikke komplette for perioden.',
  'avg.sources.allPresent': 'Kildene avstemmingen leser er på plass for perioden.',
  'avg.sources.source': 'Kilde',
  'avg.sources.unavailable': 'Ikke tilgjengelig',
  'avg.sources.complete': 'Komplett',
  'avg.main.title': 'Automatisk hovedavstemming',
  'avg.main.noAccount': 'Ingen kontrollkonto med beregnet grunnlag',
  'avg.main.differenceOpen': 'Differanse må behandles',
  'avg.main.matches': 'Bokført gjeld stemmer med kravene',
  'avg.main.bookedBalance': 'Bokført saldo på kontrollkontoer',
  'avg.main.claims': 'Beregnede og ubetalte krav',
  'avg.main.preliminaryDiff': 'Foreløpig differanse',
  'avg.main.explained': 'Forklarte poster i avstemmingen',
  'avg.main.unexplained': 'Uforklart differanse',
  'avg.main.comparedOn': 'Sammenliknet på {accounts}.',
  'avg.main.explainer': 'Kravene er foretakets egne beregnede forpliktelser fra lønn og MVA, med lovbestemt forfall. Skatteetatens egen kravoversikt hentes ikke av appen.',
  'avg.main.openClaims': 'Åpne offentlige krav',
  'avg.main.dueSoon': 'Forfaller neste 14 dager',
  'avg.main.overdue': 'Forfalt ved periodeslutt',
  'avg.main.paidInPeriod': 'Betalt i perioden',
  'avg.main.directPostings': 'Direkteføringer på kontrollkontoer',
  'avg.main.claimsNoLiability': 'Krav uten bokført gjeld',
  'avg.main.openClaimsOverview': 'Åpne kravoversikt',
  'avg.main.seePayments': 'Se betalinger',
  'avg.main.seeAccounts': 'Se kontrollkontoer',
  'avg.accounts.title': 'Kontrollkontoer i hovedboken',
  'avg.accounts.empty': 'Ingen kontrollkonto for skatt og offentlige avgifter finnes i denne perioden.',
  'avg.accounts.status.stemmer': 'Stemmer',
  'avg.accounts.status.ikke_sammenliknet': 'Ikke sammenliknet',
  'avg.accounts.status.ikke_relevant': 'Ikke relevant',
  'avg.accounts.colAccount': 'Kontrollkonto',
  'avg.accounts.colOpening': 'Inngående saldo',
  'avg.accounts.colDebit': 'Debet',
  'avg.accounts.colCredit': 'Kredit',
  'avg.accounts.colClosing': 'Utgående saldo',
  'avg.accounts.colBasis': 'Beregnet grunnlag',
  'avg.accounts.openAccount': 'Åpne konto',
  'avg.tile.betaling_mangler': 'Forfalte krav uten betaling',
  'avg.tile.betalt_for_sent': 'Betalt etter forfall',
  'avg.tile.bokforingsdifferanse': 'Bokføringsdifferanse mot kravet',
  'avg.tile.ikke_bokfort': 'Krav uten bokført gjeld',
  'avg.tile.delvis_betalt': 'Delbetalte krav',
  'avg.tile.ikke_meldt': 'Lønnskjøring ikke registrert meldt',
  'avg.tile.mva_ikke_levert': 'MVA-oppgjør ikke ferdigstilt',
  'avg.tile.direktefort': 'Direkteføringer på kontrollkonto',
  'avg.tile.uten_bankdekning': 'Betaling uten bankdekning',
  'avg.tile.betalt_etter_periode': 'Betalt etter periodeslutt',
  'avg.ctl.title': 'Kontrollkort',
  'avg.ctl.checksRun': '{count} automatiske kontroller kjørt',
  'avg.ctl.flagged': '{count} forhold krever vurdering',
  'avg.ctl.done': '{count} ferdig vurdert',
  'avg.ctl.accountsVsClaims': 'Kontrollkontoer mot krav',
  'avg.ctl.reconciledOf': '{done} av {total} avstemt',
  'avg.ctl.accountsWithBasis': 'Kontoer med beregnet grunnlag',
  'avg.ctl.activeFilter': 'Aktivt filter: {label}',
  'avg.ctl.postsCount': '{count} poster',
  'avg.ctl.reset': 'Nullstill',
  'avg.checks.title': 'Automatiske kontroller',
  'avg.checks.intro': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avg.checks.colCheck': 'Kontroll',
  'avg.checks.colRun': 'Kjøring',
  'avg.checks.colFindings': 'Funn',
  'avg.checks.ran': 'Kjørt',
  'avg.checks.findings': '{count} funn',
  'avg.checks.none': 'Ingen funn',
  'avg.common.yes': 'Ja',
  'avg.common.no': 'Nei',
  'avg.claims.titleEmpty': 'Offentlige krav i perioden',
  'avg.claims.empty': 'Perioden har ingen beregnede offentlige forpliktelser. Uten lønnskjøringer og uten MVA-termin er det ingen krav å avstemme.',
  'avg.claims.title': 'Offentlige krav — beregnet, bokført og betalt',
  'avg.claims.intro': 'Kravene er foretakets egne beregnede forpliktelser med lovbestemt forfall. Beløpet kommer fra lønnskjøringen og MVA-meldingen, ikke fra en kravoversikt hos Skatteetaten — den hentes ikke av appen.',
  'avg.claims.colType': 'Type krav',
  'avg.claims.colCalculated': 'Beregnet',
  'avg.claims.colBookedLiability': 'Bokført gjeld',
  'avg.claims.colPayment': 'Betaling',
  'avg.claims.colBooking': 'Bokføring',
  'avg.claims.draftCredit': 'Utkast: {amount} til gode',
  'avg.claims.draftPayable': 'Utkast: {amount} til betaling',
  'avg.claims.openVat': 'Åpne MVA',
  'avg.wh.title': 'Forskuddstrekk — betaling etter lønnsutbetaling',
  'avg.wh.runsWithWithholding': 'Lønnskjøringer med forskuddstrekk',
  'avg.wh.totalWithholding': 'Samlet forskuddstrekk',
  'avg.wh.paidInTime': 'Betalt innen frist',
  'avg.wh.overdueUnpaid': 'Forfalt uten betaling',
  'avg.wh.paidLate': 'Betalt etter frist',
  'avg.wh.colRun': 'Lønnskjøring',
  'avg.wh.colPayDate': 'Lønnsdato',
  'avg.wh.colWithholding': 'Forskuddstrekk',
  'avg.wh.colDeadline': 'Betalingsfrist',
  'avg.wh.colRegisteredPaid': 'Registrert betalt',
  'avg.wh.colPaymentDate': 'Betalingsdato',
  'avg.wh.colAmelding': 'A-melding',
  'avg.wh.empty': 'Ingen lønnskjøring i perioden har forskuddstrekk å betale.',
  'avg.wh.note': 'Fra 2026 betales forskuddstrekk og utleggstrekk direkte til Skatteetaten senest første virkedag etter lønnsutbetalingen. Fristen over er beregnet av lønnsmodellen, med norske helligdager. Betalingen er den som er registrert mot kjøringen — Skatteetatens KID hentes ikke av appen.',
  'avg.aga.title': 'Arbeidsgiveravgift og finansskatt',
  'avg.aga.empty': 'Ingen arbeidsgiveravgift er beregnet for terminen denne perioden hører til.',
  'avg.aga.computed': 'Beregnet i lønnssystemet',
  'avg.aga.cost': 'Bokført kostnad (5400)',
  'avg.aga.liability': 'Bokført gjeld (2770)',
  'avg.aga.term': 'Termin',
  'avg.aga.deadline': 'Betalingsfrist',
  'avg.aga.financeTax': 'Finansskatt',
  'avg.aga.financeTaxNote': 'Beregnes ikke av lønnsmodellen',
  'avg.aga.bookingDifference': 'Bokføringsdifferanse',
  'avg.aga.noBooking': 'Ingen bokføring å sammenlikne med',
  'avg.aga.matches': 'Bokført avgift stemmer med beregningen',
  'avg.aga.note': 'Bevegelsen er terminens, fra terminens start til periodeslutt. Avgiften påløper gjennom terminen, og måneden alene ville sammenliknet halve terminens føringer med hele terminens avgift.',
  'avg.aga.documentExplanation': 'Dokumenter forklaring',
  'avg.vat.title': 'MVA og oppgjør',
  'avg.vat.empty': 'Ingen MVA-termin dekker denne perioden.',
  'avg.vat.intro': 'Transaksjonskontrollene for MVA gjøres i MVA-avstemmingen — denne seksjonen viser bare oppgjørsstatus.',
  'avg.vat.reportingPeriod': 'Rapporteringsperiode',
  'avg.vat.net': 'Netto MVA i terminen',
  'avg.vat.netCredit': '{amount} til gode',
  'avg.vat.netPayable': '{amount} til betaling',
  'avg.vat.settlementBalance': 'Bokført på oppgjørskonto',
  'avg.vat.dueDate': 'Leveringsfrist',
  'avg.vat.registeredPaid': 'Registrert betalt',
  'avg.vat.termOver': 'Terminen er over i denne perioden',
  'avg.ctax.title': 'Selskapsskatt og forskuddsskatt',
  'avg.ctax.payable': 'Betalbar skatt (2500)',
  'avg.ctax.deferred': 'Utsatt skatt (2510)',
  'avg.ctax.prepaid': 'Forskuddsskatt (2540)',
  'avg.ctax.cost': 'Bokført skattekostnad hittil i år (8300)',
  'avg.ctax.note': 'Skatteavsetningen er en regnskapsmessig beregning. Ekstern avstemming skjer mot melding om forskudd, skatteoppgjør eller annet krav fra Skatteetaten — Plumme henter ingen av dem, og kontoene står derfor som «ikke sammenliknet» i kontrollkontotabellen. Neste aktuelle kontroll er årsoppgjøret eller et nytt skatteoppgjør.',
  'avg.flag.betaling_mangler': 'Forfalt — ikke betalt',
  'avg.flag.delvis_betalt': 'Delvis betalt',
  'avg.flag.betalt_for_sent': 'Betalt etter forfall',
  'avg.flag.betalt_etter_periode': 'Betalt etter periodeslutt',
  'avg.flag.bokforingsdifferanse': 'Bokføringsdifferanse',
  'avg.flag.ikke_bokfort': 'Ikke bokført som gjeld',
  'avg.flag.ikke_meldt': 'Lønnskjøring ikke registrert meldt',
  'avg.flag.mva_ikke_levert': 'MVA-melding ikke levert',
  'avg.flag.direktefort': 'Direkteført på kontrollkonto',
  'avg.flag.uten_bankdekning': 'Betaling ikke bekreftet av banken',
  'avg.assessment.ikke_vurdert': 'Ikke vurdert',
  'avg.assessment.ingen_korrigering': 'Ingen korrigering nødvendig',
  'avg.assessment.tidsforskjell': 'Tidsforskjell',
  'avg.assessment.feil_bokforing': 'Bokføringsfeil',
  'avg.assessment.manglende_betaling': 'Manglende betaling',
  'avg.assessment.manglende_bokforing': 'Manglende bokføring',
  'avg.assessment.feil_kobling': 'Feil kobling mot krav',
  'avg.assessment.tilbakebetaling': 'Tilbakebetaling eller motregning',
  'avg.assessment.rente': 'Rentekrav',
  'avg.assessment.bankgebyr': 'Gebyr',
  'avg.assessment.avventer_dokumentasjon': 'Avventer dokumentasjon',
  'avg.assessment.avventer_klienten': 'Avventer klienten',
  'avg.assessment.ikke_relevant': 'Ikke relevant',
  'avg.assessment.neste_periode': 'Følges opp neste periode',
  'avg.quick.krever_vurdering': 'Krever vurdering',
  'avg.quick.all': 'Alle',
  'avg.quick.betaling_mangler': 'Betaling mangler',
  'avg.quick.betalt_for_sent': 'Betalt for sent',
  'avg.quick.bokforingsdifferanse': 'Bokføringsdifferanse',
  'avg.quick.ikke_bokfort': 'Ikke bokført',
  'avg.quick.ikke_meldt': 'A-melding',
  'avg.quick.direktefort': 'Direkteføringer',
  'avg.quick.uten_bankdekning': 'Uten bankdekning',
  'avg.quick.ferdig_vurdert': 'Ferdig vurdert',
  'avg.quick.confirmed': 'Bekreftet av banken',
  'avg.quick.registrert': 'Registrert mot krav',
  'avg.quick.etter_frist': 'Betalt etter frist',
  'avg.quick.etter_periode': 'Etter periodeslutt',
  'avg.flagBadges.none': 'Ingen',
  'avg.flagBadges.more': '+{count} flere',
  'avg.match.registrert': 'Registrert mot krav',
  'avg.match.etter_frist': 'Registrert — etter forfall',
  'avg.match.etter_periode': 'Registrert — etter periodeslutt',
  'avg.match.direktefort': 'Direkteført — ingen kilde svarer for den',
  'avg.pay.title': 'Betalinger og posteringer på kontrollkontoene',
  'avg.pay.intro': 'Betalingene er foretakets egne registrerte oppgjør mot kravene. Er betalingen matchet mot en banklinje i bankavstemmingen, er det bankutskriften som bekrefter at pengene forlot kontoen — den eneste eksterne kilden dette området har. Direkteføringene er posteringer på kontrollkontoene som verken kommer fra en lønnskjøring, en registrert skattebetaling eller et MVA-oppgjør — et gebyr, en rente eller en manuell korrigering.',
  'avg.pay.colDescription': 'Beskrivelse',
  'avg.pay.colApplies': 'Gjelder',
  'avg.pay.colBank': 'Bankdekning',
  'avg.pay.colVoucher': 'Bilag',
  'avg.pay.bankLine': 'Banklinje {date}',
  'avg.pay.notMatched': 'Ikke matchet',
  'avg.pay.noStatement': 'Ingen bankutskrift',
  'avg.pay.empty': 'Ingen betalinger eller posteringer passer med filtrene.',
  'avg.items.title': 'Avvik og tiltak',
  'avg.items.clearFilters': 'Nullstill filtre',
  'avg.items.colMatter': 'Forhold',
  'avg.items.colAlert': 'Varsel',
  'avg.items.empty': 'Ingen forhold passer med filtrene.',
  'avg.docs.notFetched': 'Hentes ikke av appen',
  'avg.docs.inPlace': 'På plass',
  'avg.docs.title': 'Dokumentasjon',
  'avg.docs.colBasis': 'Grunnlag',
  'avg.docs.requestFromCustomer': 'Be kunden om dokumentasjon',
  'avg.docs.attached': 'Vedlagt dokumentasjon',
  'avg.docs.attachedEmpty': 'Ingen dokumenter er lastet opp på skatteområdet for denne perioden.',
  'avg.page.noAccount': 'Skatteområdet har ingen avstemmingskonto i denne perioden.',
  'avg.nav.differences': '{count} differanse',
  'avg.nav.matches': 'Stemmer',
  'avg.nav.overview': 'Oversikt',
  'avg.nav.claims': 'Krav og saldo',
  'avg.nav.claimsCount': '{count} krav',
  'avg.nav.withholding': 'Forskuddstrekk',
  'avg.nav.toAssess': '{count} til vurdering',
  'avg.nav.runs': '{count} kjøringer',
  'avg.nav.aga': 'Arbeidsgiveravgift',
  'avg.nav.oneDifference': '1 differanse',
  'avg.nav.filed': 'Levert',
  'avg.nav.notFiled': 'Ikke levert',
  'avg.nav.corporateTax': 'Selskapsskatt',
  'avg.nav.noExternalSource': 'Ingen ekstern kilde',
  'avg.nav.payments': 'Betalinger',
  'avg.nav.entries': '{count} poster',
  'avg.nav.open': '{count} åpne',
  'avg.nav.missing': '{count} mangler',
  'avg.nav.controls': 'Kontroll og godkjenning',
  'avg.page.areaLabel': 'Skatt og offentlige avgifter',
  'avg.page.hintOpen': '{count} forhold med varsel er ikke ferdig vurdert.',
  'avg.page.hintDone': 'Alle forhold med varsel er vurdert.',
  'avg.page.heading': 'Skatt og offentlige avgifter — krav, bokføring og betaling',
  'avg.page.vatTerm': 'MVA-termin {n} ({period})',
  'avg.page.responsible': 'Ansvarlig {name}',
  'avg.page.overdueBadge': '{count} forfalt krav uten betaling',
  'avg.page.noOpen': 'Ingen åpne forhold',
  'avg.page.claimsSource': 'Kravene er hentet fra lønnskjøringene og MVA-meldingen, med lovbestemt forfall.',
  'avg.page.claimsChecked': '{claims} krav er kontrollert mot bokføringen, og {unassessed} forhold krever vurdering.',
  'avg.page.notFetchedInfo': 'Plumme henter ikke kravoversikt, saldo eller KID fra Skatteetaten. Avstemmingen sammenlikner foretakets egne beregnede forpliktelser med bokføringen og de registrerte betalingene. Et fastsatt krav fra Skatteetaten må kontrolleres manuelt mot skattekontoen.',
});
